export default __webpack_public_path__ + "static/media/2.827c6f27.png";